// Public app mounted inside NLIMS's main router at /public/*.
import { useRoutes } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import Overview from './pages/Overview';
import MarketsPrices from './pages/MarketsPrices';
import FacilitiesServices from './pages/FacilitiesServices';
import StateOverview from './pages/StateOverview';
import LivestockProduction from './pages/LivestockProduction';
import ServiceProfessionals from './pages/ServiceProfessionals';
import ContactUs from './pages/ContactUs';
import Nadis from './pages/Nadis';
import Naits from './pages/Naits';
import EvetCert from './pages/EvetCert';
import NotFound from './pages/NotFound';

function App() {
  return useRoutes([
    {
      path: '/',
      element: <PublicLayout />,
      children: [
        { index: true, element: <Overview /> },
        { path: 'markets-prices', element: <MarketsPrices /> },
        { path: 'facilities-services', element: <FacilitiesServices /> },
        { path: 'state-overview', element: <StateOverview /> },
        { path: 'livestock-production', element: <LivestockProduction /> },
        { path: 'service-professionals', element: <ServiceProfessionals /> },
        { path: 'contact-us', element: <ContactUs /> },
        { path: 'nadis', element: <Nadis /> },
        { path: 'naits', element: <Naits /> },
        
        { path: 'evet-cert', element: <EvetCert /> },
        { path: '*', element: <NotFound /> },
      ],
    },
  ]);
}

export default App;
